import 'moment/locale/pt-br';
import '@fontsource/inter';

import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { ThemeProvider } from '@tmov/design-system';
import { ConfigProvider } from 'antd';
import pt_BR from 'antd/es/locale/pt_BR';
import React, { useState } from 'react';
import ReactDependentScript from 'react-dependent-script';
import ReactGA from 'react-ga4';
import { useMediaQuery } from 'react-responsive';
import { HashRouter } from 'react-router-dom';

import Routes from './routes';
import Auth from './security/Auth';
import { GlobalStyle } from './styles/global';

const App = () => {
  const [collapsed, setCollapsed] = useState(false);

  const mediaQuerys = {
    xs: useMediaQuery({ maxWidth: 576 }),
    sm: useMediaQuery({ minWidth: 577, maxWidth: 767 }),
    md: useMediaQuery({ minWidth: 768, maxWidth: 991 }),
    lg: useMediaQuery({ minWidth: 992, maxWidth: 1199 }),
    xl: useMediaQuery({ minWidth: 1200, maxWidth: 1599 }),
    xxl: useMediaQuery({ minWidth: 1600 }),
  };

  // Google Analytics
  if (
    process.env.REACT_APP_GA4_MEASUREMENTID &&
    process.env.REACT_APP_NODE_ENV !== 'development'
  ) {
    ReactGA.initialize(process.env.REACT_APP_GA4_MEASUREMENTID, {
      gaOptions: {
        name: 'shipper',
      },
    });
  }

  // Application Insights
  if (process.env.REACT_APP_APPINSIGHTS_INSTRUMENTATIONKEY) {
    const appInsights = new ApplicationInsights({
      config: {
        instrumentationKey:
          process.env.REACT_APP_APPINSIGHTS_INSTRUMENTATIONKEY,
        accountId: 'tmov - shipper',
        appId: 'tmov - shipper',
        enableAutoRouteTracking: true,
      },
    });
    const telemetryInitializer = envelope => {
      envelope.tags['ai.cloud.role'] = 'shipper.sotran.com.br';
    };
    appInsights.loadAppInsights();
    appInsights.addTelemetryInitializer(telemetryInitializer);
  }

  return (
    <HashRouter>
      <ConfigProvider locale={pt_BR}>
        <GlobalStyle />
        <ReactDependentScript
          scripts={[
            {
              source: 'https://fast.conpass.io/1sF64RKFpZ3.js',
              onerror: console.log,
              not_required: true,
            },
          ]}
        >
          <Auth>
            <ThemeProvider>
              <Routes
                collapsed={collapsed}
                setCollapsed={setCollapsed}
                mediaQuerys={mediaQuerys}
              />
            </ThemeProvider>
          </Auth>
        </ReactDependentScript>
      </ConfigProvider>
    </HashRouter>
  );
};

export default App;
